import { isDefined } from '@aloft/toolkit-shared';

import { BreakdownColumn, isSubRows } from '../types.ts';

export function getColumnHeaders(tableDef: BreakdownColumn[]): string[] {
  const headers: (string | undefined)[] = [];
  for (const col of tableDef) {
    if (isSubRows(col)) {
      // we are assuming that each subrow has the same column structure.
      // possibly we should enforce this better, but this will do for now.
      headers.push(col.subRows[0]?.header);
      for (const c of col.subRows[0]?.columns ?? []) {
        headers.push(c.header);
      }
    } else {
      headers.push(col.header);
    }
  }

  return headers.filter(isDefined);
}
